export enum SectionIds {
    PanareaSection = 'panarea-section',
    AppointmentSection = 'appointment-section',
    ReferencesSection = 'references-section'
};